import * as React from 'react';
import { observer } from 'mobx-react';
import { useOrganisationStore } from 'Global/Organisations/OrganisationsStore';
import DefaultHome from './DefaultHome';
import { themeStore } from 'Models/ThemeStore';
import { useEffect } from 'react';
import MultiOrgHome from './MultiOrgHome';
import { HOME_PAGE_TITLE } from '../../../../ConstantPageNames';
import If from '../../If/If';
import { LottieSpinner } from '../Lottie/LottieSpinner';

export interface HomeProps {
	contactUs: boolean;
}

function Home({ contactUs }: HomeProps) {
	const [homeContent, setHomeContent] = React.useState<JSX.Element | null>(null);

	useEffect(() => {
		document.title = HOME_PAGE_TITLE;
	}, []);

	const orgStore = useOrganisationStore();
	const featureImageURL = themeStore.homepageBackgroundImageURL;

	const showOrganisationSelection = (orgStore.organisations?.length ?? 0) > 1;

	useEffect(() => {
		setHomeContent(
			showOrganisationSelection ? <MultiOrgHome contactUs={contactUs} /> : <DefaultHome contactUs={contactUs} />,
		);
	}, [orgStore.organisations, orgStore.selectedOrganisation]);

	return (
		<>
			<div className="home-page__background">
				<img className="background-img" src={featureImageURL} alt="bg-img" />
				<div className="colour-overlay" />
			</div>
			<div className={`home-page__container ${showOrganisationSelection ? 'multi-org-home__container' : ''}`}>
				<If condition={orgStore.loading}>
					<LottieSpinner />
				</If>
				<If condition={!orgStore.loading}>{homeContent}</If>
			</div>
		</>
	);
}

export default observer(Home);
